import styled from "styled-components";
import React, { Component } from "react";
import AddUserButton from "./AddUserButton";
import QueryLoading from "../../animations/QueryLoading";

export const StyledForm = styled.form`
  label {
    display: block;
    margin-bottom: 20px;
  }
  input[type="text"] {
    display: block;
    margin-top: 5px;
  }
  .radioDiv {
    margin-top: 10px;
  }
  button {
    display: inline-block;
    padding: 20px;
    font-size: 20px;
    color: white;
    border-radius: 4px;
    background: ${(props) => props.theme.primaryBlue};
    width: 200px;
    text-align: center;
  }
`;

export default class AddUser extends Component {
  state = {
    email: "",
    firstName: "",
    lastName: "",
    password: "",
    ownedCourses: [],
    admin: false,
  };

  handleChange = (e) => {
    // Change strings to bools
    if (e.target.value === "true" || e.target.value === "false") {
      const booledValue = e.target.value === "true";
      this.setState({
        [e.target.name]: booledValue,
      });
      return;
    }
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  handleCoursesChange = (e) => {
    // If its in the array, add it otherwise delete it

    const value = parseInt(e.target.value);
    let ownedCourses = this.state.ownedCourses;
    const index = ownedCourses.indexOf(value);

    if (index > -1) {
      ownedCourses.splice(index, 1);
    } else {
      ownedCourses.push(value);
    }

    this.setState({
      ownedCourses,
    });
  };

  startLoader = () => {
    this.setState({
      loading: true,
    });
  };
  stopLoader = () => {
    this.setState({
      loading: false,
    });
  };
  resetState = () => {
    this.setState({
      email: "",
      firstName: "",
      lastName: "",
      password: "",
      ownedCourses: false,
      admin: false,
    });
  };

  render() {
    if (this.state.loading) {
      return <QueryLoading />;
    }
    return (
      <>
        <h1>Add User Form</h1>
        <StyledForm>
          <label>
            First name
            <input
              type="text"
              name="firstName"
              value={this.state.firstName}
              onChange={this.handleChange}
            />
          </label>
          <label>
            Last name
            <input
              type="text"
              name="lastName"
              value={this.state.lastName}
              onChange={this.handleChange}
            />
          </label>
          <label>
            Email address
            <input
              type="text"
              name="email"
              value={this.state.email}
              onChange={this.handleChange}
            />
          </label>
          <label>
            Password
            <input
              type="text"
              name="password"
              value={this.state.password}
              onChange={this.handleChange}
            />
          </label>
          <label>
            Which courses do they own?
            <div>
              {this.props.courses.map((course) => (
                <div key={course.id}>
                  <input
                    type="checkBox"
                    checked={this.state.ownedCourses.indexOf(course.id) > -1}
                    onChange={this.handleCoursesChange}
                    value={course.id}
                  />
                  {course.courseName}
                </div>
              ))}
            </div>
          </label>
          <label>
            Do they have administrative privilidges (be careful with this)?
            <div className="radioDiv">
              <input
                type="radio"
                name="admin"
                value={true}
                checked={this.state.admin === true}
                onChange={this.handleChange}
              />
              Yes
            </div>
            <div className="radioDiv">
              <input
                type="radio"
                name="admin"
                value={false}
                checked={this.state.admin === false}
                onChange={this.handleChange}
              />
              No
            </div>
          </label>
          <AddUserButton
            {...this.state}
            resetState={this.resetState}
            fetchAllUsers={this.props.fetchAllUsers}
          />
        </StyledForm>
      </>
    );
  }
}
